import React, { Component } from "react";
import {
    NavBar,
    Icon,
    List,
    Drawer,
    WhiteSpace,
    InputItem,
    Button,
    WingBlank,
    Pagination,
    Toast,
    SearchBar,
} from "antd-mobile";
import "./billMessage.scss";
import axios from "../../../service/axios";
import { connect } from "dva";
const Item = List.Item;
const Brief = Item.Brief;
@connect(({ admin }) => ({ admin }))
export class BillMessage extends Component {
    state = {
        open: false,
        billDatas: [],
        pageTotalNum: 0,
        pageNo: 1,
    };
    componentDidMount() {
        this.getAvailInfo(1);
    }
    getAvailInfo(e) {
        //延时1s，防止后台接口操作太频繁
        Toast.loading('加载中...', 1, () => {
            this.props
                .dispatch({
                    type: "admin/getQuotaUsersList",
                    payload: {
                        page: {
                            pageNo: e,
                            pageSize: 10,
                        },
                    },
                })
                .then(res => {
                    console.log(res);
                    this.setState({
                        billDatas: res.resultList,
                        pageNo: e,
                        pageTotalNum: Math.ceil(res.totalCount / 10),
                    });
                });
        });
    }
    onOpenChange = () => {
        this.setState({
            open: !this.state.open,
        });
    };
    onPageChange = e => {
        const { pageTotalNum } = this.state;
        e = e > pageTotalNum ? pageTotalNum : e;
        this.getAvailInfo(e);
    };
    render() {
        const sidebar = (
            <div className="bill-sidebar">
                <List renderHeader={() => "搜索额度信息"}>
                    <InputItem clear placeholder="登录账号">
                        登录账号
                    </InputItem>
                    <WhiteSpace size="xl" />
                    <Button type="primary">搜索</Button>
                    <WhiteSpace size="xl" />
                    <Button onClick={this.onOpenChange} type="">
                        关闭
                    </Button>
                </List>
            </div>
        );
        const { billDatas, pageTotalNum, pageNo } = this.state;
        return (
            <div className="billMessage">
                <div className="header-sticky">
                    <NavBar
                        icon={<Icon type="left" />}
                        onLeftClick={() => this.props.history.goBack()}
                    >
                        虚拟币信息
                    </NavBar>
                </div>
                <div className="sub-container">
                    <List>
                        {billDatas.map((i, index) => (
                            <Item
                                key={index}
                                arrow="horizontal"
                                multipleLine
                                onClick={() => { }}
                            >
                                登录账号： {i.loginName}
                                <Brief>总虚拟币：{i.totalCount || 0}</Brief>
                                <Brief>
                                    可用虚拟币数：{i.surplusCount || 0}
                                </Brief>
                                <Brief>已用虚拟币数：{i.usedCount || 0}</Brief>
                            </Item>
                        ))}
                    </List>
                    <WhiteSpace size="xl" />
                    <WingBlank>
                        <SearchBar
                            placeholder="请输入跳转页面"
                            onSubmit={value => this.onPageChange(value)}
                        />
                    </WingBlank>
                    <WhiteSpace size="xl" />
                    <WingBlank>
                        {pageTotalNum > 0 ? (
                            <Pagination
                                total={pageTotalNum}
                                current={pageNo}
                                locale={{
                                    prevText: "上一页",
                                    nextText: "下一页",
                                }}
                                onChange={e => this.onPageChange(e)}
                            />
                        ) : (
                                ""
                            )}
                    </WingBlank>
                </div>
            </div>
        );
    }
}

export default BillMessage;
